<template>
  <svg
    id="Basket"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20.166"
    viewBox="0 0 20 20.166"
  >
    <rect
      id="Rectangle_1651"
      data-name="Rectangle 1651"
      width="20"
      height="20"
      fill="none"
    />
    <path
      id="Path_2387"
      data-name="Path 2387"
      d="M2922,1115.9h13.333"
      transform="translate(-2918.667 -1103.404)"
      fill="none"
      stroke="#fff"
      stroke-linecap="round"
      stroke-width="2"
    />
    <path
      id="Path_2388"
      data-name="Path 2388"
      d="M2929,1110.778v5.833"
      transform="translate(-2919 -1097.445)"
      fill="none"
      stroke="#fff"
      stroke-linecap="round"
      stroke-width="2"
    />
    <path
      id="Path_2389"
      data-name="Path 2389"
      d="M2932.255,1117l2.5-10h-11.667l2.5,10"
      transform="translate(-2918.921 -1104.5)"
      fill="none"
      stroke="#fff"
      stroke-width="2"
    />
  </svg>
</template>

<script>
export default {
  name: 'Basket',
}
</script>

<style lang="scss" scoped></style>
